import { render, staticRenderFns } from "./AddEditTreatmentSurgery.vue?vue&type=template&id=078d8a74"
import script from "./AddEditTreatmentSurgery.vue?vue&type=script&lang=js"
export * from "./AddEditTreatmentSurgery.vue?vue&type=script&lang=js"
import style0 from "./AddEditTreatmentSurgery.vue?vue&type=style&index=0&id=078d8a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports